import { jsx, jsxs } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { Box, Heading, Bleed } from "braid-design-system";
import { useMemo } from "react";
import { useJobDetailsViewContext } from "../ApplySection/ApplyButton/ApplyButton.mjs";
import { defaultBoxPaddingX } from "../JDVLayout/JDVLayout.mjs";
import { forceAlignWidthToSiblings } from "../JDVLayout/JDVLayout.css.mjs";
import { translations } from "../../../components/CompetitiveJobs/.vocab/index.mjs";
import { CompetitiveJobCard } from "./CompetitiveJobCard.mjs";
import { CompetitiveJobsSkeleton } from "./CompetitiveJobsSkeleton.mjs";
import { wrapperJdvEmbeddedStyles, wrapperJdvStandaloneStyles } from "./CompetitiveJobs.css.mjs";
const CompetitiveJobs = ({
  jobs = [],
  isLoadingCompetitiveJobs,
  openInNewTab
}) => {
  const isEnableHorizontalScroll = jobs.length === 3;
  const { t } = useTranslations(translations);
  const { embedded } = useJobDetailsViewContext();
  const scrollableWrapperClass = embedded ? wrapperJdvEmbeddedStyles : wrapperJdvStandaloneStyles;
  const bleedSize = useMemo(
    () => isEnableHorizontalScroll ? {
      ...defaultBoxPaddingX,
      mobile: "none"
    } : "none",
    [isEnableHorizontalScroll]
  );
  if (isLoadingCompetitiveJobs) {
    return /* @__PURE__ */ jsx(CompetitiveJobsSkeleton, {});
  }
  return /* @__PURE__ */ jsxs(
    Box,
    {
      display: "flex",
      flexDirection: "column",
      gap: "large",
      data: { testid: "competitive-jobs" },
      className: forceAlignWidthToSiblings,
      children: [
        /* @__PURE__ */ jsx(Heading, { level: "4", children: t("Featured jobs", { jobCount: jobs.length }) }),
        /* @__PURE__ */ jsx(Bleed, { right: bleedSize, children: /* @__PURE__ */ jsx(
          Box,
          {
            display: "flex",
            gap: "xsmall",
            flexDirection: { mobile: "column", tablet: "row" },
            width: "full",
            className: {
              [scrollableWrapperClass]: isEnableHorizontalScroll
            },
            paddingRight: bleedSize,
            children: jobs.map((props, index) => /* @__PURE__ */ jsx(
              CompetitiveJobCard,
              {
                openInNewTab,
                isEnableHorizontalScroll,
                id: props.id,
                pos: index + 1,
                title: props.title,
                advertiserName: props.company.name,
                locationLabel: props.location,
                listingDateLabel: props.postedDateFormatted,
                srcLogo: props.srcLogo,
                solMetadata: props.solMetadata,
                solHash: props.solHash
              },
              index
            ))
          }
        ) })
      ]
    }
  );
};
export {
  CompetitiveJobs
};
